export default {
    title: "資料修改",
    form1: "用戶ID",
    form2: "公司名稱（中文）",
    form3: "公司名稱（英文）",
    form4: "電子郵箱",
    form5: "聯繫電話",
    form6: "手機號碼",
    form7: "聯繫地址",
    form8: "傳真號碼",
    form9: "負責人姓名",
    form10: "金額分配總額度",
    form11: "公司類別",
    form12: "所屬市場",
    // 個人
    form13: "登錄名",
    form14: "真實姓名",
    form15: "暱稱",
    form16: "營業執照",
    changeEmail: "更換郵箱",
    rule1: "請輸入公司名稱（中文）",
    rule2: "請輸入公司名稱（英文）",
    rule4: "請輸入聯繫電話",
    rule5: "請輸入手機號碼",
    rule6: "請輸入聯繫地址",
    rule7: "請輸入傳真號碼",
    rule8: "請輸入負責人姓名",
    // rule9: "請選擇地區",
    rule10: "請選擇公司類別",
    rule11: "請選擇市場",
    // 個人
    rule12: "請輸入真實姓名",
    rule13: "請輸入暱稱",
    diaTitle: "添加/修改郵箱",
    isdefault1: "設為默認郵箱",
    isdefault2: "默認",
    isdefault3: "設為默認",
    addBtn: "添加",
    table1: "郵箱",
    table2: "默認郵箱",
    table3: "操作",
    succmsg1: "此郵箱修改成功！",
    succmsg2: "修改默認成功！",
    errormsg: "郵箱不能為空！"
}